import { DEFAULT_LOCALE, SUPPORTED_LOCALES, type LocaleCode } from './locales'
import { PILOT_TRANSLATED_PATHS } from './pilot-translations'

const translatedPathsByLocale: Partial<Record<LocaleCode, Set<string>>> = {
  'pt-PT': new Set<string>((PILOT_TRANSLATED_PATHS['pt-PT'] ?? []).map(normalizePath)),
  es: new Set<string>((PILOT_TRANSLATED_PATHS.es ?? []).map(normalizePath)),
  de: new Set<string>((PILOT_TRANSLATED_PATHS.de ?? []).map(normalizePath)),
  fr: new Set<string>((PILOT_TRANSLATED_PATHS.fr ?? []).map(normalizePath)),
}

function normalizePath(pathname: string): string {
  if (!pathname) return '/'
  if (pathname === '/') return '/'
  const normalized = pathname.startsWith('/') ? pathname : `/${pathname}`
  return normalized.endsWith('/') ? normalized.slice(0, -1) : normalized
}

export function hasPathTranslation(locale: LocaleCode, pathname: string): boolean {
  if (locale === DEFAULT_LOCALE) return true

  const normalizedPath = normalizePath(pathname)
  const availablePaths = translatedPathsByLocale[locale]

  return availablePaths?.has(normalizedPath) ?? false
}

export function markPathAsTranslated(locale: LocaleCode, pathname: string): void {
  if (locale === DEFAULT_LOCALE) return

  const normalizedPath = normalizePath(pathname)
  translatedPathsByLocale[locale]?.add(normalizedPath)
}

export function getLocalizedPaths(locale: LocaleCode): string[] {
  if (locale === DEFAULT_LOCALE) return []
  return [...(translatedPathsByLocale[locale] ?? new Set<string>())]
}

export function getAvailableLocalesForPath(pathname: string): LocaleCode[] {
  return SUPPORTED_LOCALES.filter(locale => hasPathTranslation(locale, pathname))
}
